/* Star ratings for testimonials */
jQuery(document).ready(function($ = jQuery) {
	try {
		var rating = $(".rating").data('rating');

		$(".rating").rateYo({
			rating: rating,
			readOnly: true,
			starWidth: "15px",
			spacing: "2px",
			normalFill: '#fff',
		});
	} catch(err) {

	}
});